import React from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { parseIsoDate, toIsoDate } from './ecxDateUtils';
import '../layout/theme/EcxDatePicker.css';

function EcxInlineCalendar({
    value,
    onChange,
    disabled = false,
    className = '',
    min,
    max,
}) {
    const minDate = min ? parseIsoDate(min) : undefined;
    const maxDate = max ? parseIsoDate(max) : undefined;
    const selectedDate = value ? parseIsoDate(value) : null;

    const handleChange = (nextValue) => {
        if (disabled || !(nextValue instanceof Date)) {
            return;
        }

        onChange?.(toIsoDate(nextValue));
    };

    return (
        <div
            className={`ecx-inline-calendar ecx-page${disabled ? ' ecx-inline-calendar--disabled' : ''}${className ? ` ${className}` : ''}`}
            aria-label="Schedule date calendar"
        >
            <div className="ecx-inline-calendar__surface">
                <Calendar
                    className="ecx-calendar"
                    onChange={handleChange}
                    value={selectedDate}
                    minDate={minDate}
                    maxDate={maxDate}
                    prev2Label={null}
                    next2Label={null}
                    prevLabel={<i className="bi bi-chevron-left" aria-hidden="true" />}
                    nextLabel={<i className="bi bi-chevron-right" aria-hidden="true" />}
                    showNeighboringMonth
                    showFixedNumberOfWeeks
                />
            </div>
        </div>
    );
}

export default EcxInlineCalendar;
